import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default is localStorage for web
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers'; // Root reducer
import rootSaga from './sagas'; // Root saga


// Create the Saga middleware
const sagaMiddleware = createSagaMiddleware();


const persistConfig = {
  key: 'rootecom', 
  storage, 
  whitelist: ['auth','cart'], 
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store with the persisted reducer and middleware
const store = createStore(persistedReducer, applyMiddleware(sagaMiddleware));

// Run the root saga
sagaMiddleware.run(rootSaga);

const persistor = persistStore(store);

export { store, persistor };
